import type { KeyboardEvent, MouseEvent } from 'react';
import { useRouter } from 'next/navigation';
import { LinkWithPrefetch } from '@frameio/shared/routing/components/LinkWithPrefetch';

type Options = {
  replace?: boolean;
};

export function usePointerDownLink(href: string, options?: Options) {
  const router = useRouter();

  const navigate = () => {
    router[options?.replace ? 'replace' : 'push'](href);
  };

  return {
    as: LinkWithPrefetch,
    href,
    // @todo (SHU-8145): [FE] reset activeSheetId in usePointerDownLink
    onClick: (e: MouseEvent<HTMLElement>) => {
      if (e.metaKey) return;
      e.preventDefault();
    },
    onKeyUp: (e: KeyboardEvent<HTMLElement>) => {
      if (e.key === 'Enter') {
        navigate();
      }
    },
    onPointerDown: (e: MouseEvent<HTMLElement>) => {
      if (e.metaKey) return;
      navigate();
    },
  };
}
